import React, { useLayoutEffect, useRef } from "react";
import PageHero from "@/components/shared/PageHero";
import PaymentCardShowcase from "./PaymentCardShowcase";
import "./home-intro.css";

// These are the same partner/client assets already used on the website.
const ecosystemLogos = [
  { name: "Banred", src: "/assets/partners/strategic/banred.png" },
  { name: "Mastercard", src: "/assets/partners/strategic/mastercard.png" },
  { name: "Thales", src: "/assets/partners/strategic/thales.png" },
  { name: "BanEcuador", src: "/assets/clients/ecuador/banecuador.png" },
];

export default function HomeIntro() {
  const heroRef = useRef(null);

  useLayoutEffect(() => {
    const hero = heroRef.current;
    const heading = hero?.querySelector("h1");
    if (!heading) return undefined;
    let mounted = true;

    // Keep the diagonal below the entire headline, including after Poppins
    // loads or the viewport changes. The band is absolute: no layout shift.
    const positionBand = () => {
      if (!mounted) return;
      const heroBox = hero.getBoundingClientRect();
      if (!heroBox.width) return;
      const titleBox = heading.getBoundingClientRect();
      const styles = getComputedStyle(hero);
      const rise = parseFloat(styles.getPropertyValue("--intro-band-rise")) || 0;
      const minimum = parseFloat(styles.getPropertyValue("--intro-band-min-height")) || 0;
      const titleRight = (titleBox.right - heroBox.left) / heroBox.width;
      const height = Math.ceil(Math.max(minimum, titleBox.bottom - heroBox.top + rise * titleRight + 24));
      hero.style.setProperty("--intro-band-height", `${height}px`);
    };

    positionBand();
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(positionBand);
    [hero, heading, heading.parentElement].forEach((element) => observer?.observe(element));
    window.addEventListener("resize", positionBand, { passive: true });
    document.fonts?.ready?.then(positionBand);

    return () => {
      mounted = false;
      observer?.disconnect();
      window.removeEventListener("resize", positionBand);
    };
  }, []);

  return (
    <PageHero
      id="inicio"
      sectionRef={heroRef}
      eyebrow="INFRAESTRUCTURA DE PAGOS PARA LATINOAMÉRICA"
      title="Implementamos y operamos la infraestructura detrás de tus pagos."
      subtitle="CAPTEC implementa, monta, integra, certifica y procesa soluciones de medios de pago para bancos, cooperativas y fintechs, bajo un modelo llave en mano, con operación 24/7 y presencia regional."
      primaryCta={{ to: "/contacto", children: "Hablemos de tu proyecto de pagos" }}
      secondaryCta={{ to: "/servicios", children: "Explora nuestras soluciones" }}
      variant="light"
      className="page-hero--home"
      asideContent={<PaymentCardShowcase />}
      footerContent={(
        <div className="home-ecosystem" aria-label="Socios y clientes de CAPTEC">
          <span className="home-ecosystem__label">Socios y clientes</span>
          <div className="home-ecosystem__logos">
            {ecosystemLogos.map(({ name, src }) => (
              <img key={name} src={src} alt={name} width="160" height="90" loading="lazy" decoding="async" />
            ))}
          </div>
        </div>
      )}
    />
  );
}
